import { History } from 'history'

export interface TransfersState {
  filtersSearchLists: FiltersSearchLists
  lastGetTransfersListsPayload: LastGetTransfersListsPayload
  transfersLists: TransferList[]
  selectedTransfersLists: number[]
  tableTransfersListsPagination: TableTransfersListsPagination
  transferListPages: TransferListPagesData[]
  transferPageDetails?: TransferPageDetails
  receiveUser?: ReceiveUser
  receiveData?: ReceiveData
  receiveSupervisor?: ReceiveUser
  cageAddressInfo?: CageAddressInfo
  transferCages: TransferCageData[]
  transferCageDetails?: TransferCageDetails
}

export enum TransfersConfigsEnum {
  RECEIVE_WAITING_SCREEN_UPDATE_RATE_MS = 5000
}

export enum GenericApiErrors {
  Failed,
}

export interface SetProperty {
  property: keyof TransfersState
  value: TransfersState[keyof TransfersState]
}

export interface FiltersSearchLists {
  fcs: SearchFiltersFulfillmentCenter[]
  status: SearchFiltersStatus[]
  priorities: string[]
}

export interface SearchFiltersFulfillmentCenter {
  id: number
  name: string
}

export interface SearchFiltersStatus {
  id: number
  status: string
}

export interface GetTransfersListsPayload {
  idSourceFc?: number
  idDestinationFc?: number
  createdDate?: string
  shippingDate?: string
  priorities: string[]
  idsStatus: number[]
  page: number
  perPage: number
  order?: string
  orderBy?: string | number
}

export interface LastGetTransfersListsPayload {
  idSourceFc?: number
  idDestinationFc?: number
  createdDate?: string
  shippingDate?: string
  priorities: string[]
  idsStatus: number[]
}

export interface GetTransfersListsData {
  transfers: TransferList[]
  pagination: TableTransfersListsPagination
}

export interface TransferList {
  id: number
  type: string
  sourceFc: string
  destinationFc: string
  shippingDate: string
  priority: string
  startedAt: string
  finishedAt: string
  createdBy: string
  createdAt: string
  status: string
  pagesFinishedVsTotal: string
}

export interface TableTransfersListsPagination {
  currentPage: number
  perPage: number
  totalItems: number
  totalPages: number
  order?: string
  orderBy?: string | number
}

export interface TableErrorsLog {
  id: number
  message: string
}

export interface RemoveTransferListPayload {
  idList: number
  onError: () => void
  onSuccess: () => void
}

export interface DownloadTransfersListsInvoicesPayload {
  idsLists: number[]
  onError: () => void
  onSuccess: (errors: TableErrorsLog[]) => void
}

export interface IssueTransfersListsInvoicesPayload {
  idsLists: number[]
  onError: () => void
  onSuccess: (errors: TableErrorsLog[]) => void
}

export interface TransferListPagesData {
  id: number
  createdAt: string
  totalSkus: number
  status: string
  issuedNfesVsTotal: string
  startedAt: string | null
  finishedAt: string | null
  userStarted: string | null
  cagesAddresses: string[]
}

export enum PageStatusFilterIds {
  ALL_STATUS = 0,
  CLOSED = 1,
  OPENED = 2,
}

export enum PageStatusFilters {
  ALL_STATUS = 'Todos os status',
  CLOSED = 'Concluídas',
  OPENED = 'Em aberto',
}

export enum PageStatus {
  CREATED = 'CRIADA',
  STARTED = 'INICIADA',
  PAUSED = 'PAUSADA',
  FINISHED = 'FINALIZADA',
  WAITING_ISSUE = 'AGUARDANDO EMISSÃO',
  PROCESSING_ISSUE = 'PROCESSANDO EMISSÃO',
  PARTIALLY_ISSUED = 'PARCIALMENTE EMITIDA',
  CANCELED = 'CANCELADA',
}

export interface RemoveTransferListPagePayload {
  idPage: number
  onError: () => void
  onSuccess: () => void
}

export interface DownloadTransferListPagesInvoicesPayload {
  idList: number
  idsPages: number[]
  onError: () => void
  onSuccess: (errors: TableErrorsLog[]) => void
}

export interface IssueTransferListPagesInvoicesPayload {
  idsPages: number[]
  onError: () => void
  onSuccess: (errors: TableErrorsLog[]) => void
}

export interface IssueTransferListInvoicesData {
  errors: string[]
}

export interface IssueTransferPageInvoicesData {
  errors: string[]
}

export enum PageItemAddressDetailsEnum {
  COLLECT = 'collect',
  RESTOCK = 'restock'
}

export interface PageItemAddressDetails {
  address: string
  idBatch: number
  inputQuantity: number
  doneQuantity?: number
  dueDate: string
  userStarted?: string
  startedAt?: string
  userFinished?: string
  finishedAt?: string
  status: string
  observation?: string
}

export interface PageItemDetails {
  idItem: number
  idModel: number
  productCode: string
  productDescription: string
  restockQuantity: number
  originalRestockQuantity?: number
  quantityPerBox?: number
  minimumExpirationDate: string
  destinationAddress: string
  totalCollectedQuantity: number
  totalRestockedQuantity: number
  addressesCollect: PageItemAddressDetails[]
  addressesRestock: PageItemAddressDetails[]
}

export interface PageCageDetails {
  idCage: number
  address: string
  status: string
  orderCode?: string
  invoiceAccessKey?: string
  nfeStatus?: string
  nfeStatusDescription?: string
}

export interface TransferPageDetails {
  idList: number
  idPage: number
  userStarted?: string
  startedAt?: string
  userFinished?: string
  finishedAt?: string
  totalItems: number
  totalSkus: number
  status: string
  totalCollectedQuantity: number
  totalRestockedQuantity: number
  items: PageItemDetails[]
  cages: PageCageDetails[]
}

export interface TransferPageCageIssueOrDownloadPayload {
  idCage: number
  setPreventDoubleClick: React.Dispatch<React.SetStateAction<boolean>>
}

export interface DownloadInvoicesData {
  fileDownload: () => void
  errors: TableErrorsLog[]
}

export interface TransferReceiveValidateBadgePayload {
  badge: string
  history: History
  onError: (error: string) => void
}

export interface ReceiveUser {
  badge: string
  name: string
}

export interface ReceiveItemBatch {
  idBatchReceivement: number
  idBatchStockExpiration: number
  batchNumber: number
  expirationDate: string
  quantity: number
}

export interface ReceiveItemLocation {
  id: number
  address: string
}

export interface ReceiveItem {
  idModel: number
  productDescription: string
  batches: ReceiveItemBatch[]
  volume: number
  productVolume: number
  isPallet: boolean
  isGondola: boolean
  order: number
  bestPosition: ReceiveItemLocation
  gondolaAddress: ReceiveItemLocation
  isInternal: boolean
  done?: boolean
}

export interface ReceiveStartPayload {
  badge: string
  idFulfillmentCenter: number
  cageAddress: string
  invoiceAccessKey: string
  history: History
  onFinish: () => void
  inWaitingPage?: boolean
}

export interface ReceiveData {
  idCage: number
  cageAddress: string
  invoiceAccessKey: string
  idStatus: number
  status: string
  items: ReceiveItem[]
  currentItem?: ReceiveItem
}

export interface GetReceiveStatusPayload {
  badge: string
  idCage: number
}

export interface ReceiveDataStatus {
  idCage: number
  idStatus: number
  status: string
}

export interface ValidateProductBarcodePayload {
  badge: string
  idModel: number
  barcode: string
  onSuccess: () => void
  onError: (error: string) => void
}

export interface ValidateMovementAddressPayload {
  idModel: number
  address: string
  addressToValidate: string
  isGondola: boolean
  onSuccess: () => void
  onError: (error: string) => void
}

export interface ReceiveBatchesMovementPayload {
  badge: string
  idCage: number
  item: ReceiveItem
  startedAt: Date
  onSuccess: () => void
  onError: () => void
}

export interface ReceiveMovementData {
  finished: boolean
}

export interface ReceiveValidateSupervisorBadgePayload {
  badge: string
  onError: (error: string) => void
  onSuccess: () => void
}

export interface ReceiveCountBatch {
  quantity: number
  expirationDate: Date
}

export interface ReceiveSupervisorProductNotFoundPayload {
  badge: string
  idCage: number
  item: ReceiveItem
  onSuccess: () => void
  onError: () => void
}

export interface ReceiveSupervisorProductNotFoundData {
  finished: boolean
}

export interface ReceiveSupervisorCountBatchesPayload {
  badge: string
  idCage: number
  idModel: number
  idLocation: number
  batches: ReceiveCountBatch[]
  onSuccess: (goToNextStep: boolean) => void
  setPreventDoubleClick: React.Dispatch<React.SetStateAction<boolean>>
}

export interface ReceiveUnfitMovementPayload {
  badge: string
  item: ReceiveItem
  startedAt: Date
  onSuccess: () => void
  onError: () => void
}

export interface ReceiveUnfitMovementApiPayload {
  badge: string
  item: ReceiveItem
  items: ReceiveItem[]
  startedAt: Date
}

export enum TransferCageStatusEnum {
  CREATED = 1,
  WAITING_RECEIVEMENT = 2,
  IN_RESTOCKING = 3,
  FINISHED = 4,
  PROCESSING_RESERVE_CONFIRMATION = 5,
  FAILED_RESERVE_CONFIRMATION = 6,
  PROCESSING_MAIN_STOCK_ENTRY = 7,
  FAILED_MAIN_STOCK_ENTRY = 8,
  PROCESSING_PURCHASE_INTEGRATION = 9,
  FAILED_PURCHASE_INTEGRATION = 10,
  PROCESSING_FINANCES_INTEGRATION = 11,
  FAILED_FINANCES_INTEGRATION = 12,
  INTEGRATED_SUCCESSFULLY = 13,
  PROCESSING_OPERATIONAL_STOCK_ENTRY = 14,
  FAILED_OPERATIONAL_STOCK_ENTRY = 15,
  CANCELED = 99
}

export enum TransferCageStatusDescriptionEnum {
  CREATED = 'CRIADA',
  WAITING_RECEIVEMENT = 'AGUARDANDO RECEBIMENTO',
  IN_RESTOCKING = 'EM REPOSIÇÃO',
  FINISHED = 'FINALIZADA',
  PROCESSING_RESERVE_CONFIRMATION = 'PROCESSANDO CONFIRMAÇÃO DE RESERVA',
  FAILED_RESERVE_CONFIRMATION = 'FALHA AO CONFIRMAR RESERVA',
  PROCESSING_MAIN_STOCK_ENTRY = 'PROCESSANDO ENTRADA NO ESTOQUE FISCAL',
  FAILED_MAIN_STOCK_ENTRY = 'FALHA AO DAR ENTRADA NO ESTOQUE FISCAL',
  PROCESSING_PURCHASE_INTEGRATION = 'PROCESSANDO INTEGRAÇÃO COM COMPRAS',
  FAILED_PURCHASE_INTEGRATION = 'FALHA AO INTEGRAR COM COMPRAS',
  PROCESSING_FINANCES_INTEGRATION = 'PROCESSANDO INTEGRAÇÃO COM FINANCEIRO',
  FAILED_FINANCES_INTEGRATION = 'FALHA AO INTEGRAR COM FINANCEIRO',
  INTEGRATED_SUCCESSFULLY = 'INTEGRADA COM SUCESSO',
  PROCESSING_OPERATIONAL_STOCK_ENTRY = 'PROCESSANDO ESTOQUE OPERACIONAL',
  FAILED_OPERATIONAL_STOCK_ENTRY = 'FALHA AO DAR ENTRADA NO ESTOQUE OPERACIONAL',
  CANCELED = 'CANCELADA'
}

export interface CageAddressInfoFc {
  id: number
  name: string
}

export interface CageAddressInfo {
  idLocation: number
  address: string
  currentFc: CageAddressInfoFc
  availableFcs: CageAddressInfoFc[]
}

export interface ChangeCageFcPayload {
  idLocation: number
  idFc: number
  onSuccess: () => void
}

export enum CageManagementStatusFilters {
  ALL_STATUS = 'Todos os status',
  OPENED = 'Em aberto',
  FINISHED = 'Finalizadas',
  CANCELED = 'Canceladas',
}

export interface SearchTransferCagesByFiltersPayload {
  status: string
  initialDate: string
  finalDate: string
  idSourceFc?: number
  idDestinationFc?: number
  invoiceAccessKey?: string
  cageAddress?: string
  onFinally: () => void
}

export interface TransferCageData {
  idCage: number
  idPage: number
  idList: number
  address: string
  sourceFc: string
  destinationFc: string
  status: string
  createdAt: string
  firstOperator: string
  qtySkus: number
  lastOperator?: string
  updatedAt?: string
  nfeStatus?: string
  invoiceAccessKey?: string
  idReceivement?: number
}

export interface CageItemBatchDetails {
  quantity: number
  expirationDate: string
  operator: string
}

export interface CageItemDetails {
  idModel: number
  productCode: string
  productDescription: string
  sourceQuantity: number
  destinationQuantity: number
  sourceBatches: CageItemBatchDetails[]
  destinationBatches: CageItemBatchDetails[]
}

export interface TransferCageDetails {
  idCage: number
  createdBy: string
  createdAt: string
  updatedBy?: string
  updatedAt?: string
  address: string
  sourceFc: string
  destinationFc: string
  status: string
  orderCode?: string
  invoiceAccessKey?: string
  nfeStatus?: string
  items: CageItemDetails[]
}
